import { render, staticRenderFns } from "./TabDialog.vue?vue&type=template&id=9b4c72a6&scoped=true&"
import script from "./TabDialog.vue?vue&type=script&lang=js&"
export * from "./TabDialog.vue?vue&type=script&lang=js&"
import style0 from "./TabDialog.vue?vue&type=style&index=0&id=9b4c72a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b4c72a6",
  null
  
)

export default component.exports